// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 组件JSON内容 实体类
 * 元数据组件对应的JSON内容，针对于组件或应用等
 */
export class MDComponentJson extends BaseEntity {
  /** 组件ID : 组件ID */
  private _componentId: string;

  /** 设置：组件ID */
  public get componentId() {
    return this._componentId;
  }

  /** 获取：组件ID */
  public set componentId(value: string) {
    this._componentId = value;
  }

  /** JSON内容 : 组件元数据以Json格式存储的内容，每次修改需要更新 */
  private _jsonContent: string;

  /** 设置：JSON内容 */
  public get jsonContent() {
    return this._jsonContent;
  }

  /** 获取：JSON内容 */
  public set jsonContent(value: string) {
    this._jsonContent = value;
  }

  constructor() {
    super();
    this._componentId = '';
    this._jsonContent = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: MDComponentJson, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.componentId = element.componentId;
      this.jsonContent = element.jsonContent;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.componentId = json.ComponentId;
    this.jsonContent = json.JsonContent;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ComponentId = this.componentId;
    json.JsonContent = this.jsonContent;
  }

  static Create(json: any): MDComponentJson {
    const mDComponentJson = new MDComponentJson();
    mDComponentJson.Deserialize(json);
    mDComponentJson.json = json;
    return mDComponentJson;
  }
}
